// import './App.css';
import { z } from 'zod';
import { useEffect, useRef, useState } from 'react';
// import LineChart from './lineChart';
import { useForm } from 'react-hook-form';
import ReactApexChart from 'react-apexcharts';
import * as api from '../../../../services/api';
import { zodResolver } from '@hookform/resolvers/zod';
import CustomSelectWithCheckbox from '../MonthYearSelect';
import React from 'react';
import { toast } from 'react-toastify';

const categories: Array<string> = [
  'name',
  'description',
  '2025',
  '2024',
  '2023',
  '2022',
  '2021',
  '2020',
  '2019',
  '2018',
  '2017',
  '2016',
  '2015',
  '2014',
  '2013',
  '2012',
  '2011',
  '2010',
  '2009',
  '2008',
  '2007',
  '2006',
  '2005',
  '2004',
  '2003',
  '2002',
  '2001',
  '2000',
];

const monthYearRefSchema = z.object({
  reference_month: z.number().min(1, 'selecione ao menos um mês e ano.'),
  reference_year: z.number().min(1, 'selecione ao menos um mês e ano.'),
});

interface LineTendencia {
  year_model: number;
  MM: number;
  LNY: number;
  LNY2: number;
  MMLNY: number;
  matrix_A: number[];
  final_calc: {
    a0: number;
    a1: number;
    MMMEDIO: number;
    R2: number;
    PSB: number;
    PS: number;
    MMM2: number;
    VR2: number;
  };
  factors: {
    FA: number;
    FN: number;
    FC: number;
  };
}

// Criando o esquema zod com campo fixo "nome" e categorias dinâmicas
const schemaForm0 = z.object({
  product: z.string().min(1, 'Selecione um Produto.'),
  manuf: z.string().min(1, 'Selecione um Fabricante.'),
  model: z.string().min(1, 'Selecione um Modelo.'),
  yearMonthRef: z.preprocess(
    (val) => (val === undefined ? [] : val), // Transforma undefined em um array vazio
    z.array(monthYearRefSchema).min(1, 'Selecione ao Menos um Mês e Ano.'), // Valida o array
  ),
});

// Criando o esquema zod com campo fixo "nome" e categorias dinâmicas
const schemaForm1 = z.object({
  FC: z.record(
    z.string().regex(/^\d{4}$/), // Valida que as chaves são anos (formato YYYY)
    z.number().positive(), // Valores devem ser números positivos
  ),
  FN: z.string().min(1, 'Adicione Fator de Nivelação.'),
  fa_min: z.string().min(1, 'Adicione o Valor Mínimo do Range .'),
  fa_max: z.string().min(1, 'Adicione o Valor Máximo do Range .'),
});

const schemaForm2 = z.object(
  categories.reduce(
    (acc, field) => {
      acc[field] = z.string(); // Define o validador para cada categoria como string
      return acc;
    },
    {} as Record<string, z.ZodString>,
  ), // Tipagem correta para string
);

type TypeSchemaForm0 = z.infer<typeof schemaForm0>;
type TypeSchemaForm1 = z.infer<typeof schemaForm1>;
type TypeSchemaForm2 = z.infer<typeof schemaForm2>;

type monthYearRef = {
  reference_month: string;
  reference_year: string;
};

type manufs = {
  mounter_code: string;
  mounter: string;
};

type models = {
  mounter: string;
  model: string;
  model_code: string;
  description: string;
};

// Função auxiliar para carregar do localStorage
const loadState = (key: string, defaultValue: any) => {
  try {
    const saved = localStorage.getItem(key);
    if (saved !== null && saved !== 'undefined') {
      return JSON.parse(saved);
    } else {
      return defaultValue;
    }
  } catch (error) {
    console.error(`Erro ao carregar ${key} do localStorage:`, error);
    return defaultValue;
  }
};

function Graphic() {
  const [manualLineAble, setManualLineAble] = useState<boolean>(false);
  const [childValue, setchildValue] = useState<monthYearRef[]>([]);
  const [mapValue, setmapValue] = useState<any>([]);
  const [mapLine, setMapLine] = useState<any>([]);
  const [manufs, setmanufs] = useState<manufs[]>(loadState('manufs', []));
  const [models, setmodels] = useState<models[]>(loadState('models', []));
  const [modelCode, setmodelCode] = useState<string>(
    loadState('modelCode', ''),
  );
  const [description, setDescription] = useState<string>(
    loadState('description', ''),
  );
  const [monthYearOptions2, setmonthYearOptions2] = useState<any>(
    loadState('monthYearOptions2', []),
  );
  const [name] = useState<string>('');
  const [r2, setr2] = useState<string | null>(loadState('r2', null));
  const [selectedProduct, setSelectedProduct] = useState('');
  const customSelectRef = useRef<any>(null);
  const [, setLineTendencia] = useState<LineTendencia[]>([]); // Definindo o tipo do estado
  // Salvar estados no localStorage quando algum deles mudar
  useEffect(() => {
    localStorage.setItem('description', JSON.stringify(description));
    localStorage.setItem('r2', JSON.stringify(r2));
    localStorage.setItem('manufs', JSON.stringify(manufs));
    localStorage.setItem('models', JSON.stringify(models));
    localStorage.setItem('modelCode', JSON.stringify(modelCode));
    localStorage.setItem(
      'monthYearOptions2',
      JSON.stringify(monthYearOptions2),
    );
  }, [description, r2, manufs, models, modelCode, monthYearOptions2]);

  const {
    register: registerForm0,
    setValue: setValue0,
    handleSubmit: handleSubmitForm0,
    formState: { errors: errors0 },
    reset: reset0,
    clearErrors: clearErrors0,
  } = useForm<FormInputTypes0>({
    mode: 'all',
    resolver: zodResolver(schemaForm0),
    defaultValues: {
      manuf: '',
      product: '',
      model: '',
      yearMonthRef: [],
    },
  });

  const { setValue: setValue1, getValues: getValues1 } =
    useForm<TypeSchemaForm1>({
      mode: 'all',
      resolver: zodResolver(schemaForm1),
    });

  const {
    register: registerForm2,
    handleSubmit: handleSubmitForm2,
    reset: resetForm2,
  } = useForm<TypeSchemaForm2>({
    mode: 'all',
    resolver: zodResolver(schemaForm2),
  });

  useEffect(() => {
    const storedData: any = localStorage.getItem('filterInputData');
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        if (parsedData?.product) {
          setSelectedProduct(String(parsedData.product));
        }
        // Validar a estrutura de yearMonthRef
        const transformedData = {
          ...parsedData,
          //yearMonthRef: Array.isArray(parsedData.yearMonthRef) ? parsedData.yearMonthRef : [],
        };

        reset0(transformedData); // Aplicar reset com dados transformados
      } catch (error) {
        console.error('Erro ao processar os dados do localStorage:', error);
      }
    }
  }, [reset0]);

  const checkStatus = async (taskId: string): Promise<any> => {
    return new Promise((resolve, reject) => {
      let elapsedTime = 0;
      const firstRequestDelay = 2000; // 2 segundos para a primeira requisição
      const intervalTime = 30000; // 30 segundos para as seguintes
      const maxTime = 300000; // 5 minutos de tempo máximo

      const fetchStatus = async () => {
        try {
          const response: any = await api.get(
            `/table/crawler/check_status/?task_id=${taskId}`,
          );

          if (response.status === 200) {
            const status = response.data.content.status;

            if (status === 'SUCCESS') {
              clearInterval(interval);
              toast.success('Sucesso ao obter os dados.', {
                position: toast.POSITION.TOP_RIGHT,
              });
              resolve(response);
            }

            if (status === 'FAILURE') {
              clearInterval(interval);
              toast.error('Falha ao obter os dados.', {
                position: toast.POSITION.TOP_RIGHT,
              });
              resolve(null);
            }
          }
        } catch (error) {
          clearInterval(interval);
          toast.error('Erro ao verificar status!', {
            position: toast.POSITION.TOP_RIGHT,
          });
          reject(error);
        }

        elapsedTime += intervalTime;
        if (elapsedTime >= maxTime) {
          clearInterval(interval);
          toast.error('Tempo limite atingido! Tente novamente.', {
            position: toast.POSITION.TOP_RIGHT,
          });
          resolve(null);
        }
      };

      setTimeout(() => {
        fetchStatus();
        interval = setInterval(fetchStatus, intervalTime);
      }, firstRequestDelay);

      let interval: NodeJS.Timeout;
    });
  };

  const getFromLocalStorage = (): { name: string; data: number[] }[] => {
    const mapValueSaved = localStorage.getItem('mapValue');
    const manualLinesSaved = localStorage.getItem('manualLines');
    const yearSelectLocal = localStorage.getItem('YearSelectGraphicTela');
    const yearsSelect = yearSelectLocal ? JSON.parse(yearSelectLocal) : {};

    if (mapValueSaved) {
      const dataArray = JSON.parse(mapValueSaved);
      const data = Object.values(dataArray);

      const currentYear = new Date().getFullYear();
      const years = Array.from(
        { length: currentYear - 2000 + 1 },
        (_, index) => 2000 + index,
      );

      if (data.length === 1) {
        const savedLineTendencia = localStorage.getItem('lineTendencia');
        const lineTendencia = savedLineTendencia
          ? JSON.parse(savedLineTendencia)
          : [];

        if (Array.isArray(lineTendencia) && lineTendencia.length > 0) {
          const mmPorAno: Record<number, number[]> = {};
          lineTendencia.forEach((item: any) => {
            if (!mmPorAno[item.year_model]) {
              mmPorAno[item.year_model] = [];
            }
            mmPorAno[item.year_model].push(item.MM);
          });

          // Calcular a média anual de MM
          const valoresMM: number[] = [];
          const anos: number[] = [];
          Object.keys(mmPorAno).forEach((ano) => {
            const anoNumerico = Number(ano);
            const valores = mmPorAno[anoNumerico];
            const mediaMM =
              valores.reduce((sum, val) => sum + val, 0) / valores.length;

            anos.push(anoNumerico);
            valoresMM.push(mediaMM);
          });

          let tendencia: number[] = [];
          if (anos.length > 1) {
            // Aplicar regressão linear
            const n = anos.length;
            const sumX = anos.reduce((acc, x) => acc + x, 0);
            const sumY = valoresMM.reduce((acc, y) => acc + y, 0);
            const sumXY = anos.reduce((acc, x, i) => acc + x * valoresMM[i], 0);
            const sumX2 = anos.reduce((acc, x) => acc + x * x, 0);

            const a = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX);
            const b = (sumY - a * sumX) / n;

            tendencia = years.map((year) => a * year + b);
          } else {
            const unicoValor = valoresMM[0] || 0;
            tendencia = years.map(() => unicoValor);
          }

          const arrayOfLocal = [
            {
              name: 'Linha de Tendência(MM)',
              data: tendencia.reverse(),
            },
          ];

          if (manualLinesSaved) {
            const jsonmanualLines = JSON.parse(manualLinesSaved);

            jsonmanualLines.forEach((line: any, index: number) => {
              const lineName = line.name;
              const selectedYears = yearsSelect[lineName]?.data || {};
              if (index === 0) {
                line.data = years.map((year, idx) => {
                  return selectedYears[String(year)] === false
                    ? null
                    : (line.data[idx] ?? 0);
                });
                line.data = line.data.reverse();
              } else {
                const reversedYears = [...years].reverse();
                line.data = reversedYears.map((year, idx) => {
                  return selectedYears[String(year)] === false
                    ? null
                    : (line.data[idx] ?? 0);
                });
              }

              arrayOfLocal.push(line);
            });
          }
          return arrayOfLocal;
        }
      } else if (data.length > 1) {
        const arrayOfLocal: { name: string; data: number[] }[] = [];
        data.forEach((item: any) => {
          const a = createYearArrayPS([item]);
          const objt = {
            name: localStorage.getItem('description') || 'Unknown',
            data: a,
          };

          const lineName = objt.name;
          const selectedYears = yearsSelect[lineName]?.data || {};

          objt.data = years.map((year, idx) => {
            return selectedYears[String(year)] === false
              ? null
              : (objt.data[idx] ?? 0);
          });
          arrayOfLocal.push(objt);
        });

        if (manualLinesSaved) {
          const jsonmanualLines = JSON.parse(manualLinesSaved);
          jsonmanualLines.forEach((line: any) => {
            const lineName = line.name;
            const selectedYears = yearsSelect[lineName]?.data || {};

            line.data = years.map((year, idx) => {
              return selectedYears[String(year)] === false
                ? null
                : (line.data[idx] ?? 0);
            });
            arrayOfLocal.push(line);
          });
        }

        return arrayOfLocal;
      } else if (manualLinesSaved) {
        const jsonmanualLines = JSON.parse(manualLinesSaved);
        const arrayOfLocal: { name: string; data: number[] }[] = [];

        jsonmanualLines.forEach((line: any) => {
          const lineName = line.name;
          const selectedYears = yearsSelect[lineName]?.data || {};

          line.data = years.map((year, idx) => {
            return selectedYears[String(year)] === false
              ? null
              : (line.data[idx] ?? 0);
          });
          arrayOfLocal.push(line);
        });

        return arrayOfLocal;
      } else {
        return [{ name: '', data: [] }];
      }
    }

    return [{ name: '', data: [] }];
  };

  const storedSeries = getFromLocalStorage().map((series) => {
    // Definir o ano atual
    const currentYear = new Date().getFullYear();
    const years = Array.from(
      { length: currentYear - 2000 + 1 },
      (_, index) => 2000 + index,
    );

    // Ajustar os dados da linha de tendência para garantir que se alinhem com os anos
    if (series.name === 'Linha de Tendência(MM)') {
      const tendenciaData = years.map((year, index) => {
        // Preencher com o valor correto ou 0 se não houver dado
        return series.data[index] !== undefined ? series.data[index] : 0;
      });
      return { ...series, data: tendenciaData };
    }
    if (series.name !== 'Linha de Tendência(MM)') {
      return {
        ...series,
        data: series.data.map((value) => (value === 0 ? null : value)),
      };
    }
    return series;
  });

  const [chartState, setChartState] = useState<{
    series: { name: string; data: (number | null)[] }[];
    options: ApexCharts.ApexOptions;
  }>(() => {
    const currentYear = new Date().getFullYear();

    return {
      series: storedSeries.map((series) => ({
        ...series,
        data: series.data.map((value) => (value === 0 ? null : value)),
      })),
      options: {
        chart: {
          height: 350,
          type: 'line',
          zoom: { enabled: false },
        },
        dataLabels: { enabled: false },
        stroke: {
          curve: 'smooth',
          width: 2,
          dashArray: storedSeries.length ? [0] : [0], // Força sempre [0]
          lineCap: 'butt',
        },
        markers: {
          size: 2,
          strokeColors: 'none',
          strokeWidth: 2,
          hover: { size: 7 },
        },
        title: { text: '', align: 'left' },
        grid: { row: { colors: ['#f3f3f3', 'transparent'], opacity: 0.2 } },
        xaxis: {
          categories: [...Array(currentYear - 2000 + 1)]
            .map((_, i) => (2000 + i).toString())
            .reverse(),
          tickAmount: currentYear - 2000, // Ajusta o número de ticks conforme o ano atual
        },
        yaxis: {
          labels: {
            formatter: (val) =>
              val.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
          },
          // ...chartState.options.yaxis,
          min: undefined,
          forceNiceScale: true,
        },
        line: {
          connectNulls: false, // 🔹 Garante que os pontos nulos não sejam conectados
        },
        tooltip: {
          y: {
            formatter: (val) =>
              `R$ ${val.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
          },
        },
      },
    };
  });

  const setData = async (obj: TypeSchemaForm0) => {
    if (childValue.length === 0) return;

    const model0 = obj.model;

    await api
      .get(`/table/crawler/calc/factors/${obj.product}/${model0}/`)
      .then((res: any) => {
        const { FC } = res.data.content;
        const YearSelectGraphicTelalocalStorage = localStorage.getItem(
          'YearSelectGraphicTela',
        );
        const YearSelectGraphicTela = YearSelectGraphicTelalocalStorage
          ? JSON.parse(YearSelectGraphicTelalocalStorage)
          : {};
        const localStorageDescription = localStorage.getItem('description');

        const updatedYearsSelect = FC.reduce(
          (
            acc: Record<number, boolean>,
            item: { year_model: number; is_active: boolean },
          ) => {
            acc[item.year_model] = item.is_active;
            return acc;
          },
          {},
        );

        localStorage.setItem(
          'YearSelectGraphic',
          JSON.stringify(updatedYearsSelect),
        );

        const Description = localStorageDescription
          ? JSON.parse(localStorageDescription)
          : {};

        const result = {
          [Description]: {
            data: updatedYearsSelect,
          },
        };

        if (YearSelectGraphicTela) {
          const resultLocal = {
            ...YearSelectGraphicTela,
            [Description]: {
              data: updatedYearsSelect,
            },
          };

          localStorage.setItem(
            'YearSelectGraphicTela',
            JSON.stringify(resultLocal),
          );
        } else {
          localStorage.setItem('YearSelectGraphicTela', JSON.stringify(result));
        }

        const updatedFC = FC.reduce(
          (
            acc: Record<number, number>,
            item: { year_model: number; is_active: boolean; value: number },
          ) => {
            acc[item.year_model] = item.value;
            return acc;
          },
          {},
        );

        setValue1('fa_min', res.data.content.fa_min);
        setValue1('fa_max', res.data.content.fa_max);
        setValue1('FN', res.data.content.FN);
        setValue1('FC', updatedFC);
      });

    const yearSelectToCalcFinalLocal =
      localStorage.getItem('YearSelectGraphic');
    const yearSelectToCalcFinal = yearSelectToCalcFinalLocal
      ? JSON.parse(yearSelectToCalcFinalLocal)
      : {};

    const publish_params = Object.keys(yearSelectToCalcFinal).map((year) => ({
      year_model: Number(year),
      is_active: yearSelectToCalcFinal[year] ?? false,
    }));

    const dataBody = {
      params: {
        fa_min: getValues1('fa_min'),
        fa_max: getValues1('fa_max'),
        FN: getValues1('FN'),
        FC: getValues1('FC'),
        reference_dates: childValue,
      },
      publish_params,
    };

    const resp: any = await api.post(
      `/table/crawler/calc/final/${obj.product}/${model0}/`,
      dataBody,
    );

    const uuid = resp.data.content.task_id;

    toast.warning('Aguarde obter os dados.');

    const respGet: any = await checkStatus(uuid);
    if (!respGet.data?.content?.result?.calculation_results?.results) {
      toast.error('Dados não disponíveis na resposta da API', {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    const finalCalc = respGet.data.content.result.calculation_results.results;
    const [, firstValue] = Object.entries(finalCalc)[0] as [
      string,
      Record<string, any>,
    ];

    const savedLineTendencia = localStorage.getItem('lineTendencia');

    // Se já existir um valor salvo, não atualiza
    if (!savedLineTendencia) {
      const newLineTendencia = Object.values(firstValue);
      setLineTendencia(newLineTendencia);
      localStorage.setItem('lineTendencia', JSON.stringify(newLineTendencia)); // Salva no localStorage
    }

    const firstYearKey = Object.keys(firstValue)[0];
    const firstR2 = firstValue[firstYearKey]?.final_calc?.R2;

    setr2(firstR2);

    setMapLine(Object.values(firstValue));

    const mapValueSaved = localStorage.getItem('mapValue');

    if (mapValueSaved) {
      const data = JSON.parse(mapValueSaved);

      if (data.length === 1) {
        const saved = localStorage.getItem('manualLines');

        if (saved) {
          // let data;

          // try {
          //     data = JSON.parse(saved);
          // } catch (error) {
          //     console.error('Erro ao parsear JSON:', error);
          //     data = [];
          // }

          const yearArray = createYearArrayPS(
            Object.values(firstValue),
          ).reverse();

          if (Array.isArray(yearArray)) {
            const currentYear = new Date().getFullYear();
            const years = Array.from(
              { length: currentYear - 2000 + 1 },
              (_, index) => 2000 + index,
            );
            const yearSelectLocal = localStorage.getItem(
              'YearSelectGraphicTela',
            );
            const yearsSelect = yearSelectLocal
              ? JSON.parse(yearSelectLocal)
              : {};

            let manualLines = JSON.parse(
              localStorage.getItem('manualLines') || '[]',
            );

            const lineName = description; // Nome da linha
            const selectedYears = yearsSelect[lineName]?.data || {};
            const reversedYears = [...years].reverse();

            const processedData = yearArray.map((value, idx) => {
              if (selectedYears[String(reversedYears[idx])] === false)
                return null;
              return value === 0 ? null : value;
            });

            manualLines.push({
              name: description,
              data: processedData,
            });

            localStorage.setItem('manualLines', JSON.stringify(manualLines));

            setChartState((prevState) => ({
              ...prevState,
              series: [
                ...prevState.series,
                {
                  name: description,
                  data: processedData,
                },
              ],
            }));
          } else {
            console.error('yearArray não é um array válido:', yearArray);
          }
        } else {
          const yearArray = createYearArrayPS(Object.values(firstValue));

          const newData = [
            {
              name: description,
              data: yearArray,
            },
          ];

          localStorage.setItem('manualLines', JSON.stringify(newData));
        }
      } else {
        setmapValue([Object.values(firstValue)[0]]);
        // localStorage.setItem('mapValue', JSON.stringify(firstValue));
      }
    } else {
      setmapValue([Object.values(firstValue)[0]]);
      // localStorage.setItem('mapValue', JSON.stringify(firstValue));
    }

    //resetForm0();
  };

  const addLine = (data: TypeSchemaForm2) => {
    if (data.description === '' || data.name === '') {
      return;
    }

    const sortedByValues = Object.entries(data).sort(([keyA], [keyB]) =>
      keyB.localeCompare(keyA),
    );

    const newDataArray: Array<number | null> = sortedByValues
      .slice(2)
      .map(([key, value]) => {
        const numValue = Number(value);
        if (!isNaN(numValue)) {
          return numValue === 0 ? null : numValue;
        } else {
          return null;
        }
      });

    const currentYear = new Date().getFullYear();
    const years = Array.from(
      { length: currentYear - 2000 + 1 },
      (_, index) => 2000 + index,
    );
    const yearSelectLocal = localStorage.getItem('YearSelectGraphicTela');
    const yearsSelect = yearSelectLocal ? JSON.parse(yearSelectLocal) : {};

    let manualLines = JSON.parse(localStorage.getItem('manualLines') || '[]');

    const lineName = data.description;
    const selectedYears = yearsSelect[lineName]?.data || {};
    const reversedYears = [...years].reverse();

    const processedData = newDataArray.map((value, idx) => {
      if (selectedYears[String(reversedYears[idx])] === false) return null;
      return value;
    });

    manualLines.push({
      name: data.description,
      data: processedData,
    });

    localStorage.setItem('manualLines', JSON.stringify(manualLines));

    setChartState((prevState) => ({
      ...prevState,
      series: [
        ...prevState.series,
        {
          name: data.description ? data.description : data.name,
          data: processedData,
        },
      ],
    }));

    resetForm2();
  };

  type FormInputTypes0 = z.infer<typeof schemaForm0>;

  const handleValueFromChild = (value: monthYearRef[]) => {
    setchildValue(value);
  };

  const getProd = async (prod: string) => {
    handleClearSelections();
    setmonthYearOptions2([]);
    setSelectedProduct(prod);
    localStorage.setItem('monthYearOptions2', '');
    setmodels([]);
    setmanufs([]);
    setValue0('yearMonthRef', []);
    localStorage.removeItem('selectedOptions');
    setmonthYearOptions2([]);
    const resp: any = await api.get(`table/search/mounter/${prod}/`);
    await getManuf(resp.data.content);
    return;
  };

  const getManuf = async (manufs: any) => {
    setmanufs(manufs);
    return;
  };

  const getModel = async (manufCode: string) => {
    handleClearSelections();
    await api
      .get(`table/search/codes/${selectedProduct}/${manufCode}/`)
      .then((response: any) => {
        setmodels(response.data.content);
      });
  };

  const getmodelCode = async (modelCode: string) => {
    handleClearSelections();
    setmodelCode(modelCode);
    await handlemonthYearOptions2(modelCode);
  };

  const handlemonthYearOptions2 = async (modelCode: string) => {
    await api
      .get(
        `/table/crawler/calc/reference_dates/${selectedProduct}/${modelCode}/`,
      )
      .then((res: any) => {
        if (res.status === 200) {
          setmonthYearOptions2(res.data.content);
        }
        if (res.status === 404) {
          toast.error(res.data.content.detail, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setmodelCode('');
          setmodels([]);
          setmanufs([]);
          reset0();
          setValue0('product', '');
          setValue0('yearMonthRef', []);
          setValue0('model', '');
          setValue0('manuf', '');
        }
      })
      .catch((err: any) => {
        toast.error('Ops, ocorreu um erro! Tente novamente mais tarde', {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  function createYearArrayPS(newObj: any) {
    const startYear = 2000;
    const currentYear = new Date().getFullYear();

    // Quantidade de anos desde 2000 até o ano atual
    const arraySize = currentYear - startYear + 1;

    // Cria um array preenchido com zeros
    const yearArray = new Array(arraySize).fill(0);

    // Percorre cada objeto no array e preenche a posição correta com o preço
    newObj.forEach((obj: any) => {
      const yearPosition = obj.year_model % 100;

      // Verifica se a posição calculada está dentro do tamanho do array
      if (yearPosition >= 0 && yearPosition < arraySize) {
        yearArray[yearPosition] = obj.final_calc.PSB;
      }
    });

    return yearArray;
  }

  useEffect(() => {
    const a = createYearArrayPS(mapValue);
    const allZeros = a.every((num) => num === 0);

    if (description === 'i' || name === 'i' || allZeros) {
      return;
    }

    if (mapValue.length > 0) {
      const addManual = createYearArrayPS(mapLine);

      const obj = {
        name: description,
        data: addManual,
      };

      const lines = localStorage.getItem('manualLines');

      if (lines) {
        const linesForm = JSON.parse(lines);

        linesForm.push(obj);
        localStorage.setItem('manualLines', JSON.stringify(linesForm));
      } else {
        localStorage.setItem('manualLines', JSON.stringify([obj]));
      }
    }

    //Encontra o array mapValue no localStorage
    const mapV = localStorage.getItem('mapValue');

    if (mapV) {
      const mapValueArray = JSON.parse(mapV);

      if (mapValueArray.length === 0) {
        mapValueArray.push(mapValue[0]);
        localStorage.setItem('mapValue', JSON.stringify(mapValueArray));
      }
    } else if (mapValue !== undefined) {
      localStorage.setItem('mapValue', JSON.stringify(mapValue));
    }

    setChartState((prevState) => ({
      ...prevState,
      series: getFromLocalStorage(),
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapValue, setmapValue]);

  const clearChartData = () => {
    setChartState({
      options: {
        ...chartState.options,
      },
      series: [],
    });
    handleClearSelections();
    handleValueFromChild([]);
    setmapValue([]);
    setmonthYearOptions2([]);
    setLineTendencia([]);
    // localStorage.clear()
    clearErrors0();
    // setchildValue([])
    setr2(null);
    localStorage.removeItem('YearSelectGraphic');
    localStorage.removeItem('YearSelectGraphicTela');
    localStorage.removeItem('YearSelectGraphicTela');
    localStorage.removeItem('manualLines');
    localStorage.removeItem('r2');
    localStorage.removeItem('mapValue');
  };

  const handleClearSelections = () => {
    if (customSelectRef.current) {
      customSelectRef.current.clearSelections();
    }
  };

  // useEffect(() => {
  //     handleClearSelections()
  // }, [])

  const machines = [
    { id: '4', name: 'CARROCERIAS' },
    { id: '6', name: 'COLHEITADEIRA' },
    // { id: "2", name: "Helicóptero" },
    { id: '3', name: 'SEMIRREBOQUE' },
    { id: '1', name: 'TRATOR' },
  ];

  return (
    <div className="flex justify-center items-center bg-white w-full h-max rounded-b-xl ">
      <div className="bg-white rounded-b-xl w-full min-h-[80vh] h-max flex flex-col sm:p-9  py-8 px-6 sm:px-12">
        <h2 className="text-[24px] font-semibold text-gray-600">GRÁFICO</h2>
        <div className="flex flex-col sm:flex-row mt-3 mb-4 w-full justify-between">
          <form
            className="flex flex-col flex-wrap sm:flex-nowrap justify-center items-start w-full sm:w-[60%]"
            onSubmit={handleSubmitForm0((data) => {
              setData(data);
              // Limpar os campos após adicionar
              setValue0('product', '');
              setValue0('manuf', '');
              setValue0('model', '');
              setValue0('yearMonthRef', []);
            })}
          >
            <div className="flex flex-col sm:flex-row mt-12 w-full">
              <label
                htmlFor=""
                className="flex flex-col w-full sm:w-[33%] text-gray-500 font-semibold"
              >
                Produto
                <select
                  id=""
                  className={`px-2 rounded-full sm:rounded-none sm:rounded-l-full w-full border-2 ${errors0.product ? 'border-red-400' : 'border-gray-200'} text-[14px] font-semibold text-gray-500 h-11`}
                  {...registerForm0('product')}
                  onChange={(e) => {
                    getProd(e.target.value);
                    clearErrors0('product');
                  }}
                >
                  <option value="" disabled selected>
                    PRODUTO
                  </option>
                  {machines.map((machine) => (
                    <option
                      className="text-[#6B7280] font-semibold"
                      key={machine.id}
                      value={machine.id}
                    >
                      {machine.name}
                    </option>
                  ))}
                </select>
                {errors0.product && (
                  <span className="text-red-500 text-sm font-normal">
                    {errors0.product.message}
                  </span>
                )}
              </label>

              <label
                htmlFor=""
                className="flex flex-col w-full sm:w-[33%] text-gray-500 font-semibold"
              >
                Fabricante
                <select
                  id=""
                  className={`px-2 w-full border-2 rounded-full sm:rounded-none ${errors0.manuf ? 'border-red-400' : 'border-gray-200'} text-[14px] font-semibold text-gray-500 h-11`}
                  {...registerForm0('manuf')}
                  onChange={(e) => {
                    getModel(e.target.value);
                    clearErrors0('manuf');
                  }}
                >
                  <option value="" selected hidden>
                    FABRICANTE
                  </option>
                  {manufs?.map((item: any) => {
                    return (
                      <option value={item.mounter_code}>{item.mounter}</option>
                    );
                  })}
                </select>
                {errors0.manuf && (
                  <span className="text-red-500 text-sm font-normal">
                    {errors0.manuf.message}
                  </span>
                )}
              </label>
              <label
                htmlFor=""
                className="flex flex-col w-full sm:w-[33%] text-gray-500 font-semibold"
              >
                Modelo
                <select
                  id=""
                  className={`px-2 rounded-full sm:rounded-none sm:rounded-r-full w-full border-2 ${errors0.model ? 'border-red-400' : 'border-gray-200'} text-[14px] font-semibold text-gray-500 h-11`}
                  {...registerForm0('model')}
                  onChange={(e) => {
                    clearErrors0('model');
                    getmodelCode(e.target.value);
                    const selectedItem = models?.find(
                      (item: any) => item.model_code === e.target.value,
                    );
                    if (selectedItem) {
                      setDescription(selectedItem.description);
                    } else {
                      setDescription('');
                    }
                  }}
                >
                  <option value="" selected hidden>
                    MODELO
                  </option>
                  {models?.map((item: any) => {
                    return (
                      <option value={item.model_code}>
                        {item.description}
                      </option>
                    );
                  })}
                </select>
                {errors0.model && (
                  <span className="text-red-500 text-sm font-normal">
                    {errors0.model.message}
                  </span>
                )}
              </label>
            </div>

            <div className="w-full sm:w-[100%] flex flex-col sm:flex-row justify-start items-start align-top gap-2 sm:pr-3 sm:mt-12">
              <CustomSelectWithCheckbox
                ref={customSelectRef}
                onSelectionChange={handleValueFromChild}
                options={monthYearOptions2 || []}
                register={registerForm0}
                setValue={setValue0}
                errors={errors0}
                clearErrors={clearErrors0}
                saveLocalStorage={false}
              />

              <div className="flex items-end w-full sm:w-[33%]">
                <button
                  className="bg-[#6fbf8c] text-white h-11 rounded-full w-full py-4 px-10 flex justify-center items-center text-[14px] font-semibold mt-6"
                  type="submit"
                >
                  ADICIONAR
                </button>
              </div>
            </div>
          </form>
          <label htmlFor="" className="mt-20">
            <button
              className="bg-[#00AEEF] text-white h-10 rounded-full w-full sm:w-max text-nowrap py-4 px-6 flex justify-center items-center text-[14px] font-semibold"
              onClick={() => setManualLineAble(!manualLineAble)}
            >
              ADICIONAR MANUALMENTE
            </button>
          </label>
        </div>
        {manualLineAble ? (
          <form
            className="shadow-[0px_0px_5px_0px_rgba(0,0,0,0.1)] min-h-[30vh] h-max rounded-md p-4 mt-4"
            action=""
            onSubmit={handleSubmitForm2(addLine)}
          >
            <p className="text-[12px] font-semibold text-gray-500">
              ADICIONANDO LINHA MANUALMENTE
            </p>
            <div className="divTable">
              <table className="min-w-full rounded-lg mt-6 tableFilter">
                <thead>
                  <tr>
                    <th className="bg-gray-300 text-gray-400 min-w-[240px]">
                      NOME
                    </th>
                    <th className="bg-gray-300 text-gray-400 min-w-[240px]">
                      DESCRIÇÃO
                    </th>
                    {chartState.options.xaxis?.categories?.map((el: any) => (
                      <th className="bg-gray-300 text-gray-400 min-w-[120px]">
                        {el}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {categories.map((el) => {
                      return (
                        <td>
                          <input
                            type="text"
                            key={el}
                            className="h-full w-full p-0 border-none outline-none"
                            {...registerForm2(el)}
                          />
                        </td>
                      );
                    })}
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="mt-10 w-full text-right flex items-end justify-end">
              <button
                className="bg-[#6fbf8c] text-white h-10 rounded-full w-full sm:w-max py-4 px-6  mx-2 flex justify-center items-center text-[14px] font-semibold mt-5"
                type="submit"
              >
                SALVAR
              </button>
            </div>
          </form>
        ) : (
          <></>
        )}
        <div className="mt-9 overflow-hidden">
          {/* <LineChart name={objToSend.name} values={objToSend.values} /> */}
          <div>
            <div
              id="chart"
              className="divTable w-full overflow-x-auto overflow-y-hidden"
            >
              <div className="w-full min-w-[600px]">
                <ReactApexChart
                  options={chartState.options}
                  series={chartState.series}
                  type="line"
                  height={350}
                  width="100%"
                />
              </div>
            </div>

            <div className="mt-4 mb-4 flex justify-end">
              <button
                className="bg-red-500 hover:bg-red-600 text-white rounded-full px-10 h-11 text-[14px] font-semibold"
                onClick={clearChartData}
              >
                LIMPAR GRÁFICO
              </button>
            </div>

            <div id="html-dist"></div>
            <p className="font-bold z-0 text-red-500 text-center">R²: {r2}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Graphic;
